module.exports = __webpack_public_path__ + "static/media/benefitsOfficeAlarm@2x.770880cd.jpg";